import React, { useState, useEffect } from 'react';

function formatTime(date, label) {
  if (!date) return '';
  var h = date.getHours();
  var m = date.getMinutes();
  return (label || 'Last saved at') + ' ' + (h < 10 ? '0' : '') + h + ':' + (m < 10 ? '0' : '') + m;
}

export default function AutosaveIndicator({ saveStatus, lastSavedAt, onRetry, translations }) {
  var t = translations;
  var timeLabelState = useState('');
  var timeLabel = timeLabelState[0];
  var setTimeLabel = timeLabelState[1];

  useEffect(function() {
    if (saveStatus !== 'saved' || !lastSavedAt) return;
    setTimeLabel(formatTime(lastSavedAt, t.last_saved_at));
  }, [saveStatus, lastSavedAt, t.last_saved_at]);

  var stateClass = 'autosave-indicator';
  if (saveStatus === 'saving') stateClass += ' autosave-indicator--saving';
  else if (saveStatus === 'saved') stateClass += ' autosave-indicator--saved';
  else if (saveStatus === 'error') stateClass += ' autosave-indicator--error';

  if (saveStatus === 'idle') {
    return (
      <span className="autosave-indicator">
        <span className="autosave-indicator__dot" />
        <span>{t.autosave_enabled}</span>
      </span>
    );
  }

  if (saveStatus === 'saving') {
    return (
      <span className={stateClass}>
        <span className="autosave-indicator__dot" />
        <span>{t.saving}</span>
      </span>
    );
  }

  if (saveStatus === 'saved') {
    return (
      <span className={stateClass}>
        <span className="autosave-indicator__dot" />
        <span>{timeLabel}</span>
      </span>
    );
  }

  if (saveStatus === 'error') {
    return (
      <span className={stateClass}>
        <span className="autosave-indicator__dot" />
        <span>Error saving</span>
        {onRetry && (
          <button type="button" className="autosave-indicator__retry" onClick={onRetry}>
            Retry
          </button>
        )}
      </span>
    );
  }

  return null;
}
